import {
  DO_RESTORE_DELETED_BUSINESS,
  DO_RESTORE_DELETED_BUSINESS_SEARCH,
  RESTORE_DELETED_BUSINESS_CLEAR_BUSINESS_INFO,
  RESTORE_DELETED_BUSINESS_DO_SHOW_LOG,
  RESTORE_DELETED_BUSINESS_LOG_CHANGE_PAGE,
  RESTORE_DELETED_BUSINESS_LOG_SET_DATA,
  RESTORE_DELETED_BUSINESS_LOG_SET_ERRORS,
  RESTORE_DELETED_BUSINESS_LOG_SET_IS_LOADING,
  RESTORE_DELETED_BUSINESS_LOG_SET_SHOWN,
  RESTORE_DELETED_BUSINESS_SET_BUSINESS_INFO,
  RESTORE_DELETED_BUSINESS_SET_SEARCH_ERROR,
  RESTORE_DELETED_BUSINESS_SET_SEARCH_LOADING,
  RESTORE_DELETED_BUSINESS_SET_SUBMIT_ERROR,
  RESTORE_DELETED_BUSINESS_SET_SUBMIT_LOADING,
  RESTORE_DELETED_BUSINESS_SET_SUBMIT_SUCCESS,
} from 'state/actionTypes';

export const doSearchBusiness = businessId => ({
  type: DO_RESTORE_DELETED_BUSINESS_SEARCH,
  payload: { businessId },
});

export const setSearchLoading = isLoading => ({
  type: RESTORE_DELETED_BUSINESS_SET_SEARCH_LOADING,
  payload: { isLoading },
});

export const setSearchError = error => ({
  type: RESTORE_DELETED_BUSINESS_SET_SEARCH_ERROR,
  payload: { error },
});

export const setBusinessInfo = businessInfo => ({
  type: RESTORE_DELETED_BUSINESS_SET_BUSINESS_INFO,
  payload: { businessInfo },
});

export const clearBusinessInfo = () => ({
  type: RESTORE_DELETED_BUSINESS_CLEAR_BUSINESS_INFO,
});

export const doRestoreBusiness = (businessId, ticketLink, notes) => ({
  type: DO_RESTORE_DELETED_BUSINESS,
  payload: { businessId, ticketLink, notes },
});

export const setSubmitLoading = isLoading => ({
  type: RESTORE_DELETED_BUSINESS_SET_SUBMIT_LOADING,
  payload: { isLoading },
});

export const setSubmitError = error => ({
  type: RESTORE_DELETED_BUSINESS_SET_SUBMIT_ERROR,
  payload: { error },
});

export const setSubmitSuccess = success => ({
  type: RESTORE_DELETED_BUSINESS_SET_SUBMIT_SUCCESS,
  payload: { success },
});

export const doShowLogs = () => ({
  type: RESTORE_DELETED_BUSINESS_DO_SHOW_LOG,
});

export const setLogModalShown = shown => ({
  type: RESTORE_DELETED_BUSINESS_LOG_SET_SHOWN,
  payload: { shown },
});

export const setLogPage = page => ({
  type: RESTORE_DELETED_BUSINESS_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setLogData = (data, paging) => ({
  type: RESTORE_DELETED_BUSINESS_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetLogData = () =>
  setLogData([], { page: 1, size: 20, total: 0 });

export const setLogIsLoading = isLoading => ({
  type: RESTORE_DELETED_BUSINESS_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setLogErrors = errors => ({
  type: RESTORE_DELETED_BUSINESS_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearLogErrors = () => setLogErrors([]);
